import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';

import { IconComponent } from '../../../icon/icon.component';
import { BaseButtonDirective } from '../../base-button';
import type { RtAddNewButtonVariant } from '../../button.types';

@Component({
  selector: 'rt-add-new-button, a[rt-add-new-button]',
  templateUrl: './add-new-button.component.html',
  styleUrls: ['./../../styles/base.less', './add-new-button.component.less'],
  // eslint-disable-next-line
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslatePipe, IconComponent],
})
export class AddNewButtonComponent extends BaseButtonDirective {
  public readonly variant = input<RtAddNewButtonVariant>('default');
  public readonly text = input<string>(undefined!);
  // Only works for default button
  public readonly alignHorizontal = input<'left' | 'center' | 'right'>('left');
}
